import {
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { QrCodeScannerOutlined as QrCodeIcon } from "@mui/icons-material";
import CodeRedemptionModal from "@/components/CodeRedemptionModal";
import { useLiteRaveCreateContext } from "../LiteRaveCreateContext";

export const CodeSection = () => {
  const {
    redemptionCode,
    handleCodeChange,
    handleCodeBlur,
    loading,
    searchLoading,
    codeError,
    validatedCodeData,
    scannerOpen,
    setScannerOpen,
    handleCodeScanned,
    codePoints,
    setCodePoints,
    pointLimit,
  } = useLiteRaveCreateContext();

  return (
    <>
      <CodeRedemptionModal
        open={scannerOpen}
        setOpen={setScannerOpen}
        onClose={handleCodeScanned}
      />

      <Typography variant="h6" sx={{ mb: 2 }}>
        Redemption Code (Optional)
      </Typography>

      <TextField
        fullWidth
        label="Redemption Code"
        value={redemptionCode}
        onChange={(e) => handleCodeChange(e.target.value)}
        onBlur={handleCodeBlur}
        sx={{ mb: 3 }}
        disabled={loading || searchLoading}
        placeholder="Enter or scan a redemption code"
        error={!!codeError}
        helperText={
          codeError ||
          (validatedCodeData && redemptionCode.trim()
            ? "✓ Code verified and ready to attach"
            : "Leave empty to create a new code automatically")
        }
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {searchLoading ? (
                <CircularProgress size={20} />
              ) : (
                <IconButton
                  onClick={() => setScannerOpen(true)}
                  disabled={loading || searchLoading}
                  edge="end"
                >
                  <QrCodeIcon />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />

      {(!redemptionCode.trim() ||
        (redemptionCode.trim() && validatedCodeData && !codeError)) && (
        <TextField
          fullWidth
          label="Points Value"
          type="number"
          value={codePoints}
          onChange={(e) => setCodePoints(Number(e.target.value))}
          sx={{ mb: 3 }}
          disabled={
            loading ||
            (!!validatedCodeData?.isFixedValue &&
              !!validatedCodeData?.fixedValuePoints)
          }
          inputProps={{ min: 1, max: pointLimit }}
          helperText={
            validatedCodeData?.isFixedValue &&
            validatedCodeData?.fixedValuePoints
              ? `Fixed value code: ${validatedCodeData.fixedValuePoints} points (cannot be changed)`
              : "How many points should this code be worth?"
          }
        />
      )}
    </>
  );
};
